import { supabase } from '@/integrations/supabase/client';
import { handleError } from '@/utils/handleError';
import { toast } from 'sonner';
import { translateOutsideReact } from '@/i18n/translateOutsideReact';
import { downloadBlob } from '@/utils/downloadBlob';

export type TargetSystem = 'bokio' | 'fortnox';

export class DocumentExportApiClient {
  static async exportDocuments(
    fiscalYearId: string,
    targetSystem: TargetSystem,
    filename: string
  ): Promise<void> {
    try {
      const { data, error } = await supabase.functions.invoke('document-export-api', {
        body: { action: 'exportDocuments', fiscalYearId, targetSystem },
      });

      if (error) {
        await handleError(error, translateOutsideReact('consultantErrors.fallback.failedToExportDocuments'), 'exportDocuments');
        return;
      }

      downloadBlob(data, filename, 'application/zip');

      toast.success(translateOutsideReact('consultantToasts.api.exportDownloaded'));
    } catch (error) {
      await handleError(error, translateOutsideReact('consultantErrors.fallback.failedToExportDocuments'), 'exportDocuments');
      throw error;
    }
  }
}
